import { ResponseListDto, ResponseDataDto } from "@/dto/ResponseDto";
import {
  BoardCommentListItemDto,
  BoardCommentListRequestDto,
  BoardCommentCreateRequestDto,
  BoardCommentUpdateRequestDto,
} from "@/dto/BoardCommentDto";
import instance from "./instance";
import { ENV } from "@/constants/env";

const PREFIX_PATH = "admin/board/comment";

/**
 * 게시판 댓글 목록 조회
 * @param params 게시판 댓글 목록 조회 파라미터
 * @returns 게시판 댓글 목록 조회 응답
 */
export const findAll = async (
  params?: BoardCommentListRequestDto
): Promise<ResponseListDto<BoardCommentListItemDto>> => {
  // undefined 값은 제외하고 실제 값이 있는 파라미터만 전송
  const cleanParams = Object.entries(params || {})
    .filter(([, value]) => value !== undefined && value !== "")
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}/list`, {
    params: cleanParams,
  });
};

/**
 * 게시판 댓글 생성
 * @param data 게시판 댓글 생성 요청 데이터
 * @returns 생성된 댓글 정보
 */
export const create = async (
  data: BoardCommentCreateRequestDto
): Promise<ResponseDataDto<BoardCommentListItemDto>> => {
  return await instance.post(`${ENV.PRE_FIX}/${PREFIX_PATH}`, data);
};

/**
 * 게시판 댓글 수정
 * @param commentId 댓글 ID
 * @param data 게시판 댓글 수정 요청 데이터
 * @returns 수정된 댓글 정보
 */
export const update = async (
  commentId: string,
  data: BoardCommentUpdateRequestDto
): Promise<ResponseDataDto<BoardCommentListItemDto>> => {
  return await instance.put(`${ENV.PRE_FIX}/${PREFIX_PATH}/${commentId}`, data);
};

/**
 * 게시판 댓글 삭제
 * @param commentId 댓글 ID
 * @returns 삭제 결과
 */
export const remove = async (
  commentId: string
): Promise<ResponseDataDto<boolean>> => {
  return await instance.delete(`${ENV.PRE_FIX}/${PREFIX_PATH}/${commentId}`);
};
